<div class="pt-4 text-center">
    <h1>Logging you out...</h1>
</div>
